export default __webpack_public_path__ + "static/media/compliance.6418d7d3.webp";